import * as React from 'react'
import { ReactElement } from 'react'
import { VatType } from '../../../config/i18nConfig'
import useVatTypes from '../../../hooks/useVatTypes'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'

export type VatTypeComboboxProps = Omit<I18NComboboxProps<VatType>, 'entities' | 'idKey'>

export default function VatTypeCombobox(props: VatTypeComboboxProps): ReactElement {
    const { vatTypes } = useVatTypes()

    return <I18NCombobox<VatType> entities={vatTypes} idKey={'id'} placeholderKey={'base.vattypecombobox.placeholder'} {...props} />
}
